import * as types from './types';

export function addFlashMessage(message, msgType = 'error', statusCode) {
    return {
        type: types.ADD_FLASH_MESSAGE,
        msgType,
        message,
        statusCode,
    };
}

export const clearFlashMessage = () => ({
    type: types.CLEAR_FLASH_MESSAGE,
});



// WEBPACK FOOTER //
// ./src/js/actions/flash-messages.js